
import { Vue, Component, Prop } from 'vue-property-decorator';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';

@Component
export default class MerchantDivision extends Vue {
  @lazyInject(ShopService)
  shopService!: ShopService;

  @Prop()
  shopId!: number;

  @Prop()
  type!: string;

  visible = false;

  gradeData: any = {
    grade: 1,
    nextGradeScoreGap: 0,
    gradeInfo: [],
    totalScore: 0,
    scoreList: [],
    protected: false,
    industryTotalScore: '',
  };

  disNone = ['增加环境设施标签数量', '配置品牌故事'];

  columns = [
    {
      title: '分值',
      dataIndex: 'score',
      key: 'score',
      scopedSlots: { customRender: 'score' },
      width: '120px',
    },
    {
      title: '评分规则',
      dataIndex: 'conditionDesc',
      key: 'conditionDesc',
    },
  ];

  current = 0;

  scoreDetails = [];

  tasksList: any[] = [];

  allTasksList: any[] = [];

  EShopScore: any = {
    提升广告投放天数: {
      name: '提升广告投放天数',
      type: 'link',
      formName: '',
      sideType: 'out',
      url: 'https://ads.amap.com/gd-pc/ads-pc-home/agency',
      parameter: '',
      alertText: '',
    },
    增加环境设施标签数量: {
      name: '增加环境设施标签数量',
      type: 'link',
      formName: '',
      sideType: '',
      parameter: '',
      alertText: '',
    },
    配置品牌故事: {
      name: '配置品牌故事',
      type: 'link',
      formName: '',
      sideType: '',
      parameter: '',
      alertText: '',
    },
    配置门店相册视频: {
      name: '配置门店相册视频',
      type: 'link',
      formName: 'main.shop.detail',
      sideType: 'in',
      parameter: '',
      alertText: '',
    },
    提升交易核销订单量排名: {
      name: '提升同城订单排名',
      type: 'alter',
      formName: '',
      sideType: '',
      parameter: '',
      alertText: '优化团购商品结构与价格竞争力，带动销量增长与排名跃升',
    },
    提升门店评分: {
      name: '提升门店评分',
      type: 'link',
      formName: '',
      sideType: '',
      parameter: '',
      alertText: '',
    },
    配置官方相册视频: {
      name: '配置官方相册视频',
      type: 'link',
      formName: 'main.shop.detail',
      sideType: 'in',
      parameter: '3',
      alertText: '',
    },
    配置门店相册图片: {
      name: '配置门店相册图片',
      type: 'link',
      formName: 'main.shop.detail',
      sideType: 'in',
      parameter: '3',
      alertText: '',
    },
    配置门店营业时间: {
      name: '配置门店营业时间',
      type: 'link',
      formName: 'main.shop.detail',
      sideType: 'in',
      parameter: '1',
      alertText: '',
    },
    发布有价格竞争力的团购商品: {
      name: '发布有价格竞争力的团购商品',
      type: 'link',
      formName: 'main.shop.detail',
      sideType: 'in',
      parameter: '4',
      alertText: '',
    },
    配置官方相册图片: {
      name: '配置官方相册图片',
      type: 'link',
      formName: 'main.shop.detail',
      sideType: 'in',
      parameter: '3',
      alertText: '',
    },
    配置门店地址或上门服务范围: {
      name: '配置门店地址或上门服务范围',
      type: 'link',
      formName: 'main.shop.detail',
      sideType: 'in',
      parameter: '1',
      alertText: '',
    },
    配置门店相册主图: {
      name: '配置门店相册主图',
      type: 'link',
      formName: 'main.shop.detail',
      sideType: 'in',
      parameter: '3',
      alertText: '',
    },
    配置门店联系电话: {
      name: '配置门店联系电话',
      type: 'link',
      formName: 'main.shop.detail',
      sideType: 'in',
      parameter: '1',
      alertText: '',
    },
    配置门店封面图: {
      name: '配置门店封面图',
      type: 'link',
      formName: 'main.shop.detail',
      sideType: 'in',
      parameter: '3',
      alertText: '',
    },
    提升差评回复率: {
      name: '提升差评回复率',
      type: 'alter',
      formName: '',
      sideType: '',
      parameter: '',
      alertText:
        '主动回复每一条差评，展现商家的重视与诚意，有效挽回顾客信任，并提升店铺服务形象。',
    },
  };

  callback(key: number) {
    // console.log(key);
    if (key != -1) {
      this.tasksList = this.allTasksList.filter((item) => item.tag == key);
    } else {
      this.tasksList = this.allTasksList;
    }
  }

  achievementRate(current: number, total: number) {
    if (!current && !total) {
      return '--';
    }
    return `${Math.floor((current / total) * 10000) / 100}%`;
  }

  getPercenttop(val: number, deno: number) {
    console.log(val, deno);
    return `--percent: ${Math.floor((val / deno) * 10000) / 100}`;
  }

  formatToOneDecimal(value: any) {
    const num = Number(value);
    if (isNaN(num) || !isFinite(num)) {
      return '0.0';
    }
    return num.toFixed(1);
  }

  mounted() {
    // const a = document.getElementsByClassName('ant-steps-item-process')[0];
  }

  updateDynamicTail(val: number, deno: number) {
    function updateTailGradient(element: HTMLElement, percent: number) {
      const clamped = (percent / deno) * 100;
      // 设置 CSS 变量（必须带 % 单位！）
      element.style.setProperty('--percent', `${clamped}%`);
    }
    const element = document.querySelector(
      '.ant-steps-item-process .ant-steps-item-tail',
    ) as HTMLElement;
    if (element) {
      updateTailGradient(element, val);
    }
  }

  buttonDate(item: any) {
    const d = this.EShopScore[item.taskName];
    console.log(d);
    if (d.type === 'link') {
      // console.log(d)
      if (d.sideType === 'in') {
        let name = d.formName;
        if (this.type === 'shop') {
          name = 'main.shop.detail';
        } else if (this.type === 'VirtualShop') {
          name = 'main.shop.virtualDetail';
        }
        const routeUrl = this.$router.resolve({
          name,
          params: {
            id: `${this.shopId}`,
            type: d.parameter,
          },
        });
        window.open(routeUrl.href, '_blank');
      } else if (d.sideType === 'out') {
        window.open(d.url, '_blank');
      }
    } else if (d.type === 'alter') {
      const h = this.$createElement;
      this.$info({
        title: d.name,
        content: h('div', {}, [h('p', d.alertText)]),
        onOk() {},
      });
    }
  }
  init() {
    console.log('商家分类组件初始化成功!');
    this.getScoreBase();
  }

  async getScoreBase() {
    Promise.all([
      this.shopService.getShopScoreBase(this.shopId, this.$el),
      this.shopService.getShopScoreTasks(this.shopId, {
        clientSource: 'PC_C31',
      }),
    ]).then((res: any) => {
      console.log(res);
      this.tasksList = res[1];
      this.allTasksList = res[1];
      const { grade, gradeInfo, totalScore, scoreList, industryTotalScore } =
        res[0];
      const tags = new Set(res[1].map((item: any) => item.tag));
      this.gradeData = {
        grade: +grade,
        gradeInfo: gradeInfo.gradeNodes.reverse(),
        nextGradeScoreGap: gradeInfo.nextGradeScoreGap,
        realGrade: gradeInfo.realGrade,
        protected: gradeInfo.protected,
        showGrade: +gradeInfo.showGrade,
        protectedDays: gradeInfo.protectedDays,
        totalScore,
        industryTotalScore,
        scoreList: scoreList.filter((item: any) => tags.has(item.key)),
      };
      this.getScoreTeps(this.gradeData);
    });
  }

  getGradeName(value: string, gradeInfo: any) {
    if (gradeInfo.protected && value == gradeInfo.showGrade) {
      return `${value }（保级中）`;
    }
    return value;
  }

  getScoreTeps(date: any) {
    const { realGrade, gradeInfo, nextGradeScoreGap } = date;
    if (realGrade > 0 && realGrade < gradeInfo.length) {
      const current = gradeInfo[realGrade].conditionScope[0];
      const prev = gradeInfo[realGrade - 1].conditionScope[0];
      this.$nextTick(() => {
        this.updateDynamicTail(
          Math.floor(current - prev - nextGradeScoreGap),
          Math.floor(current - prev),
        );
      });
    }
  }

  openScoreDetails(item: any) {
    this.visible = true;
    const { scoreRule } = item;
    console.log(scoreRule);
    this.scoreDetails = scoreRule;
  }
  async getScoreDetail() {
    const res = await this.shopService.getShopScoreTasks(this.shopId, {
      clientSource: 'PC_C31',
    });

    if (res) {
      this.tasksList = res;
      this.allTasksList = res;
    }
  }

  getPercent(current: number, total: number) {
    return Math.floor((current / total) * 100);
  }

  onClose() {
    this.visible = false;
  }
}
